/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from "react";
import CreatableReactSelect from "react-select/creatable";
import ChakraReactSelect from "./chakra-react-select";
var CreatableSelect = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(ChakraReactSelect, props, /*#__PURE__*/React.createElement(CreatableReactSelect, {
  ref: ref
})));
export default CreatableSelect;
//# sourceMappingURL=creatable-select.js.map